module.exports = __webpack_public_path__ + "media/AUDIO 08.12440685.mp3";